import {
  UPDATE_COMPANY_SEARCH_TERM,
  SHOW_LOADING_INDICATOR,
  FETCHED_COMPANY_SUGGESTIONS,
  ERROR_FETCHING_SUGGESTIONS,
  SELECT_COMPANY,
  NO_MATCHING_COMPANIES,
} from '../constants';

export const updateCompanySearchTerm = (term) => async (dispatch) => {
  dispatch({ type: UPDATE_COMPANY_SEARCH_TERM, payload: term });
};

export const showLoadingIndicator = () => async (dispatch) => {
  dispatch({ type: SHOW_LOADING_INDICATOR });
};

export const setSuggestionsError = () => async (dispatch) => {
  dispatch({ type: ERROR_FETCHING_SUGGESTIONS });
};

export const saveCompanySuggestions = (suggestions) => async (dispatch) => {
  dispatch({ type: FETCHED_COMPANY_SUGGESTIONS, payload: suggestions });
};

// Sets the selected company in our redux store.
export const selectCompany = (company) => async (dispatch) => {
  dispatch({ type: SELECT_COMPANY, payload: company });
};

export const setNoMatchingCompanies = () => async (dispatch) => {
  dispatch({ type: NO_MATCHING_COMPANIES });
};
